// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__246ip","newExpiryDate":"styles_newExpiryDate__30BR_","footer":"styles_footer__2ZnP8"};